import { Card, Col, Row, Typography } from "antd";
import { ReactComponent as IconAI } from "assets/images/AI-icon.svg";
// import { SubscriptionType } from "enums/SubscriptionType";
// import { useCallback } from "react";
import { useSelector } from "react-redux";
import { BusinessState } from "redux-context/business";
// import { updateAiAutoAccept } from "services/SauceService";

const AIMatch: React.FC = () => {
  // const dispatch = useDispatch<any>();
  const { business } = useSelector((state: BusinessState) => state.business);

  // const aiAutoAccept =
  //   subscription?.subscriptionType === SubscriptionType.ActiveWithAIAutoAccept;

  // const onChangeAutoAccept = useCallback(
  //   async (checked: boolean) => {
  //     try {
  //       const businessId = localStorage.getItem("businessId");
  //       await updateAiAutoAccept({ businessId, enabled: checked });
  //       dispatch(getBusinessInfo());
  //     } catch (error) {
  //       message.error("Failed to update AI auto accept");
  //     }
  //   },
  //   [dispatch]
  // );

  return (
    <Card className="business-info">
      <Row justify="center" gutter={[20, 32]}>
        <Col xs={20}>
          <Typography.Text>
            <IconAI /> AI-Matched Creators
          </Typography.Text>
          <p style={{ margin: "0 0 0 20px" }}>
            Mustard AI automatically matches and accepts Creators on your
            behalf, saving time and ensuring a steady flow of campaigns.
          </p>
        </Col>
        <Col xs={4}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Typography.Text>
              {business.AIAutoAcceptEnabled ? "✅ ON" : "OFF"}
            </Typography.Text>
          </div>
        </Col>
        <Col xs={20}>
          <Typography.Text>📢 Promotions</Typography.Text>
          <p style={{ margin: "0 0 0 20px" }}>
            Create and manage special promotions like discounts or freebies to
            boost engagement and drive traffic from influencer campaigns.
          </p>
        </Col>
        <Col xs={4}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Typography.Text>
              {business.promotionEnabled ? "✅ ON" : "OFF"}
            </Typography.Text>
          </div>
        </Col>
        <Col xs={20}>
          <Typography.Text>💵 Custom compensation</Typography.Text>
          <p style={{ margin: "0 0 0 20px" }}>
            Offer flexible compensation: food, cash, or affiliate commissions
          </p>
        </Col>
        <Col xs={4}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Typography.Text>
              {business.selfManagedCompensationEnabled ? "✅ ON" : "OFF"}
            </Typography.Text>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default AIMatch;
